import { cn } from '../../lib/utils';

export default function CampaignCardSkeleton({
  className
}: Readonly<{
  className?: string;
}>) {
  return (
    <div
      className={cn(
        'h-full w-48 animate-pulse overflow-hidden rounded-2xl bg-white shadow-lg drop-shadow-lg',
        className
      )}
    >
      <div className="relative flex h-24 w-full items-center justify-center p-0">
        <div className="absolute inset-0 h-full w-full bg-gray-200"></div>
      </div>
      <div className="flex flex-col items-center space-y-4 p-3 pb-4">
        <div className="h-4 w-full rounded bg-gray-200"></div>
        <div className="h-4 w-3/4 rounded bg-gray-200"></div>
      </div>
    </div>
  );
}
